module.exports = __webpack_public_path__ + "img/c41c003.png";